import axios from "axios";
import { ArrowLeft } from "lucide-react";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl } from "../../../Environments/environment";
export default function ForgotPassword() {
	const [formData, setFormData] = useState({ email: "" });
	const handlerChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};
	const navigate = useNavigate();
	const [requestSent, setRequestSent] = useState(false);

	const handleResetPassword = async (e) => {
		e.preventDefault();
		const { email } = formData;
		if (!email) {
			return;
		}
		try {
			const response = await axios.post(`${baseUrl}/auth/forgotpassword`, {
				email,
			});

			toast.success(
				"Reset password email sent successfully. Please check your inbox.",
			);
			setRequestSent(true);
		} catch (error) {
			console.error("Error:", error?.response?.data?.message);
			toast.error(
				error?.response?.data?.message ||
					"An error occurred. Please try again.",
			);
		}
	};
	return !requestSent ? (
		<>
			<div className="px-6 py-8 sm:px-10">
				<h1 className="text-3xl font-bold tracking-tight text-gray-900">
					Forgot Password
				</h1>
				<form
					onSubmit={handleResetPassword}
					method="POST"
					className="space-y-6 mt-6"
				>
					<div>
						<label
							htmlFor="email"
							className="block text-sm font-medium leading-6 text-gray-900 sr-only"
						>
							Email address
						</label>
						<div className="mt-2">
							<input
								id="email"
								name="email"
								type="email"
								autoComplete="email"
								required
								placeholder="Enter Email"
								value={formData.email}
								onChange={(e) => handlerChange(e)}
								className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
							/>
						</div>
					</div>
					<div>
						<button
							type="submit"
							className="flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
						>
							Reset password
						</button>
					</div>
				</form>
			</div>
			<div className="border-t-2 border-gray-200 bg-gray-50 px-6 py-6 sm:px-10 w-full">
				<p className="text-xs leading-5 text-gray-500">
					Don't have an account?{" "}
					<Link className="underline text-indigo-700" to="/register">
						Sign up
					</Link>{" "}
					or{" "}
					<Link className="underline text-indigo-700" to="/">
						Sign in
					</Link>
				</p>
			</div>
		</>
	) : (
		<>
			<div className="px-6 py-8 sm:px-10">
				<div className="flex flex-col gap-2">
					<h1 className="text-3xl font-bold tracking-tight text-gray-900 mb-5">
						Link sent to email
					</h1>
					<div className="mt-2">
						Follow the instruction provided in the email
					</div>
					<div className="mt-2">
						<Link
							className="bg-neutral-200 p-2 rounded-md text-sm font-medium flex justify-center items-center px-3 gap-2 w-fit"
							to={"/"}
						>
							<ArrowLeft />
							Back to login page
						</Link>
					</div>
				</div>
			</div>
			<div className="border-t-2 border-gray-200 bg-gray-50 px-6 py-6 sm:px-10 w-full">
				<p className="text-xs leading-5 text-gray-500">
					Don't have an account?{" "}
					<Link className="underline text-indigo-700" to="/register">
						Sign up
					</Link>{" "}
				</p>
			</div>
		</>
	);
}
